import { combineReducers } from 'redux'
import { reducer as formReducer } from 'redux-form'
import { reducer as notificationsReducer } from 'reapop'
import uiReducer from './features/ui/reducer'
import reducerRoom from './reducers/reducerRoom'


export default combineReducers({
    form: formReducer,
    notifications: notificationsReducer(),
    ui: uiReducer,
    roomStatus: reducerRoom.roomStatus,
    rooms: reducerRoom.rooms
})



// WEBPACK FOOTER //
// ./src/display/reducers.js